import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'
const testUrl = localStorage.getItem(TEST_URl)

let baseUrl, submitBaseUrl
if (testUrl) {
  baseUrl = `${testUrl}/kyc`
  submitBaseUrl = `${testUrl}/kyc/submit`
} else {
  baseUrl = `${process.env.VUE_APP_BASE_URL}/kyc`
  submitBaseUrl = `${process.env.VUE_APP_BASE_URL}/kyc/submit`
}
export async function submitKycDetailsStepService (payload) {
  const res = await axios.put(
    `${submitBaseUrl}/${payload.type}/${payload.kycStep}`,
    { ...payload.kycDetailsForm }
  )
  return res
}
export async function submitKycDetailsStepFormUploadService (payload) {
  const res = await axios.put(
    `${submitBaseUrl}/${payload.type}/${payload.kycStep}`,
    payload.kycDetailsForm,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
  return res
}
export async function submitKycFinalStageService () {
  const res = await axios.post(`${submitBaseUrl}`)
  return res
}
export async function getKycDetailsService () {
  const res = await axios.get(`${baseUrl}`)
  return res
}
export async function getKycDisputesService (businessId) {
  const res = await axios.get(
    `${baseUrl}/disputes?business_id=${businessId}&status=pending`
  )
  return res
}
export async function getAttestationDocumentService () {
  const res = await axios.get(`${baseUrl}/attestation-document-url`)
  return res
}
export async function sendEmailVerificationService (payload) {
  const res = await axios.get(`${baseUrl}/verify-biometrics?email=${payload}`)
  return res
}
export async function removeDirectorService (id) {
  const res = await axios.delete(`${baseUrl}/delete-director-information/${id}`)
  return res
}
